<div *ngIf="(loading$ | async) || (downloading$ | async)" class="spinner">
  <mat-spinner></mat-spinner>
</div>

<h1 class="table__title">{{folder?.propertiesObj?.FolderName}}</h1>

<ul class="table__control inline-list">
  <li>
    <mat-checkbox *ngIf="(userRoles$ | async)?.superUser" class="custom-check-box" [checked]="showDeleted"
      (change)="changeShowDeleted()">Show
      Deleted Documents</mat-checkbox>
  </li>
  <li>
    <button [disabled]="!selection || selection.selected.length == 0 || (downloading$ | async)" mat-raised-button
      class="grey-btn" (click)="download()">
      <mat-icon><img src="assets/images/icon-download.svg" /></mat-icon>
      Download
    </button>
  </li>
  <li>
    <button *ngIf="folder?.permissions?.includes('LINK')" mat-raised-button class="grey-btn"
      [routerLink]="['../..','DocumentAdd',folder.id]">
      <mat-icon><img src="assets/images/icon-add.svg" /></mat-icon>
      Contract
    </button>
  </li>
  <li>
    <mat-form-field>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search for contract" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </li>
</ul>

<div class="download_error">
  <div *ngIf="downloadTimedOut" class="alert alert-warning">Unable to download file</div>
</div>

<div class="table__container">
  <ng-template #noDocuments>
    <h3>No Documents</h3>
  </ng-template>

  <div class="alert alert-warning" *ngIf="selection && selection.selected.length > 1">Selecting multiple contracts for
    download may take a long time or even
    time out</div>
  <table *ngIf="folder?.documents?.length > 0;else noDocuments" class="table__inner" mat-table [dataSource]="dataSource"
    matSort (matSortChange)="applySort($event)">

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="ContractDeletedDate">
      <th mat-header-cell mat-sort-header *matHeaderCellDef align="center">
        Icon
      </th>
      <td mat-cell *matCellDef="let element" align="center">

        <mat-icon><img
            [src]="element?.propertiesObj.ContractDeletedDate ? 'assets/images/icon-invalid.svg' : 'assets/images/icon-file.svg'" />
        </mat-icon>

      </td>
    </ng-container>

    <ng-container matColumnDef="Name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let element"><a (click)="closeDialog()"
          [routerLink]="['/',objectStore,'DocumentView',element.id]">
          {{ element?.propertiesObj.DocumentTitle }}</a></td>
    </ng-container>

    <ng-container matColumnDef="ContractIdentifier">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Contract ID
      </th>
      <td (click)="preview(element)" mat-cell *matCellDef="let element" class="cell-center">
        {{ element?.propertiesObj.ContractIdentifier }}</td>
    </ng-container>

    <ng-container matColumnDef="ContractStartDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Contract Start Date
      </th>
      <td (click)="preview(element)" mat-cell *matCellDef="let element" class="cell-center">
        {{ element?.propertiesObj.ContractStartDate | aspenDate }}</td>
    </ng-container>
    <ng-container matColumnDef="ContractEndDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Contract End Date
      </th>
      <td (click)="preview(element)" mat-cell *matCellDef="let element" class="cell-center">
        {{ element?.propertiesObj.ContractEndDate| aspenDate }}
      </td>
    </ng-container>
    <ng-container matColumnDef="ContractDateOfLastSignature">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Signature Date
      </th>
      <td (click)="preview(element)" mat-cell *matCellDef="let element" class="cell-center">
        {{ element?.propertiesObj.ContractDateOfLastSignature| aspenDate }}</td>
    </ng-container>
    <ng-container matColumnDef="ContractReviewDeadlineDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Review Deadline Date
      </th>
      <td (click)="preview(element)" mat-cell *matCellDef="let element" class="cell-center">
        {{ element?.propertiesObj.ContractReviewDeadlineDate| aspenDate }}
      </td>
    </ng-container>
    <ng-container matColumnDef="ContractStatus">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td (click)="preview(element)" mat-cell *matCellDef="let element" class="cell-center">
        {{ element?.propertiesObj.ContractStatus | asyncChoiceList:objectStore:'ContractStatuses' | async }}</td>
    </ng-container>
    <ng-container matColumnDef="DateCreated">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Date Loaded
      </th>
      <td (click)="preview(element)" mat-cell *matCellDef="let element" class="cell-center">
        {{ element?.propertiesObj.DateCreated| aspenDate }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true">
    </tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

</div>
<mat-paginator class="table__pagination" [pageSizeOptions]="[5, 10, 25, 100]" (page)="paged($event)"></mat-paginator>
